import { Injectable } from "@angular/core";
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from "@angular/common/http";
import { Observable } from "rxjs";
import { apiEnvironment } from "@kells/clinic-one/environments";
import { VirtualCheckupHandoffService } from "../virtual-checkup-handoff/virtual-checkup-handoff.service";
import { HALEON_APP_HEADER } from "../haleon/constants";

/**
 * Uses virtual-checkup handoff bearer token for API calls when present (mobile QR flow).
 * Runs after Auth0/SSO so the handoff token wins for member API requests.
 */
@Injectable()
export class VirtualCheckupHandoffInterceptor implements HttpInterceptor {
  constructor(private handoff: VirtualCheckupHandoffService) {}

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    if (!request.url.startsWith(apiEnvironment.apiBaseUrl)) {
      return next.handle(request);
    }
    if (request.headers.has(HALEON_APP_HEADER)) {
      return next.handle(request);
    }
    const token = this.handoff.getToken();
    if (!token) {
      return next.handle(request);
    }
    return next.handle(
      request.clone({
        setHeaders: { Authorization: `Bearer ${token}` },
      })
    );
  }
}
